import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Languages and namespaces. Add a locale: drop a folder under locales/, add
// the code below, and the Vite glob import picks it up at build time.
export const SUPPORTED_LANGUAGES = ['en', 'bg', 'de', 'es', 'fr', 'it', 'nl', 'pl'];
const NAMESPACES = ['b2c', 'admin', 'legal'];

// Vite-only: import all locale JSON files at build time. The result is a
// flat map keyed by relative path; we reshape it into the i18next resources tree.
const modules = import.meta.glob('./locales/*/*.json', { eager: true });

const resources = Object.fromEntries(
  SUPPORTED_LANGUAGES.map((lang) => [
    lang,
    Object.fromEntries(
      NAMESPACES.map((ns) => [ns, modules[`./locales/${lang}/${ns}.json`].default]),
    ),
  ]),
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'en',
    ns: NAMESPACES,
    defaultNS: 'b2c',
    fallbackNS: NAMESPACES,
    interpolation: { escapeValue: false },
    detection: {
      // localStorage first so the admin language toggle wins; then browser/html.
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vq_lang',
    },
  });

export default i18n;
